/**
 * HorizontalCardMask component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const HorizontalCardMask = styled.div`
  background: linear-gradient(
    7deg,
    rgba(0, 0, 0, 0.9) 16.82%,
    rgba(0, 0, 0, 0) 43.26%
  );
  height: ${200 * Screen.widthRatio}px;
  position: relative;
  top: ${-202 * Screen.widthRatio}px;
  width: ${350 * Screen.widthRatio}px;
`;

export default HorizontalCardMask;
